const auth = {
  errors: {
    handoff: {
      description: 'Cette session ne peut plus être reprise.',
      suggestion: 'Retournez à Safety Center et ouvrez une nouvelle session de chat.',
      suggestionHeading: 'Prochaine étape :',
      title: 'Lien de session indisponible',
    },
    network: {
      description: 'Impossible de se connecter au serveur de chat.',
      suggestions: {
        connection: 'Vérifiez que votre connexion Internet fonctionne.',
        retry: 'Réessayez dans quelques instants.',
      },
      suggestionHeading: 'Ce que vous pouvez essayer :',
      title: 'Échec de connexion au serveur',
    },
    server: {
      description: 'Le serveur de chat rencontre des problèmes.',
      suggestions: {
        refresh: "Essayez d'actualiser la page.",
        support: 'Contactez le support si le problème persiste.',
        wait: 'Attendez quelques instants que le serveur se rétablisse.',
      },
      suggestionHeading: 'Ce que vous pouvez essayer :',
      title: 'Erreur du serveur',
    },
  },
  loading: {
    almostReady: 'Presque prêt',
    initializing: 'Initialisation de SpeedGauge Coach AI',
    preparingDashboard: 'Préparation de votre tableau de bord',
    securingConnection: 'Sécurisation de votre connexion',
    validatingCredentials: 'Validation des identifiants',
  },
  actions: {
    returnToSafetyCenter: 'Retourner à Safety Center',
    retryConnection: 'Réessayer',
    retryConnectionTitle: 'Réessayer de se connecter au serveur',
    retryingConnection: 'Nouvelle tentative...',
    retryingConnectionLabel: 'Nouvelle tentative de connexion',
    returnToSafetyCenterTitle: 'Retourner à Safety Center',
  },
  guard: {
    creatingSession: 'Création de votre session...',
    redirectLoopDetected: 'La connexion n’a pas pu être effectuée. Veuillez réessayer.',
    redirectingToSignIn: 'Redirection vers la connexion...',
  },
  lastError: 'Dernière erreur : {{time}}',
  loadingSession: 'Chargement de votre session...',
  sessionUnavailable: 'Votre session est indisponible. Veuillez vous reconnecter.',
} as const;

export default auth;